import { create } from 'zustand';

const useAuthStore = create((set) => ({
  isAuthenticated: false,
  isInitialized: false,
  userData: null,
  token: null,

  login: (userData, token) => {
    set({
      isAuthenticated: true,
      userData,
      token
    });
    localStorage.setItem('userData', userData);
    localStorage.setItem('isLogin', 'true');
  },

  logout: () => {
    set({
      isAuthenticated: false,
      userData: null,
      token: null
    });
    localStorage.removeItem('userData');
    localStorage.removeItem('adminId');
    localStorage.removeItem('adminName');
    localStorage.removeItem('adminPhone');
    localStorage.removeItem('isLogin');
  },

  initializeAuth: () => {
    const isLogin = localStorage.getItem('isLogin');
    const userData = localStorage.getItem('userData');
    if (isLogin === 'true' && userData) {
      set({ 
        isAuthenticated: true,
        userData,
        isInitialized: true,

      });
    }
  },
}));

export default useAuthStore;

